export default "__VITE_ASSET__DIyzHz2v__"